var progressTemplate = require("@/modules/components/video-progress.handlebars");
const helper = require("@/helpers/index.js");

class VideoProgress extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.inputSeekbarElement = null;
        this.seekingVideo = false;
        this.videoElement = null;
    }

    getDataFromAttributes() {
        this.colorPrimary = this.getAttribute("color-primary") ? this.getAttribute("color-primary") : "#acacac";
        this.size = this.getAttribute("size") ? this.getAttribute("size") : "0% 100%";
        this.playingTime = this.getAttribute("playing-time") ? helper.formatVideoTime(parseInt(this.getAttribute("playing-time"))) : helper.formatVideoTime(0);
        this.duration = this.getAttribute("duration") ? parseInt(this.getAttribute("duration")) : 0;
        this.durationVideoTime = this.getAttribute("duration-video-time") ? this.getAttribute("duration-video-time") : helper.formatVideoTime(0);
        this.videoWrapper = this.getAttribute("video-wrapper") ? this.getAttribute("video-wrapper") : ".lora-short";
        this.normalMode = this.getAttribute("pip") !== null ? false : true;
    }

    connectedCallback() {
        this.getDataFromAttributes()
        this.initial()
    }

    async initial() {
        const template = document.createElement("template");
        var context = {
            colorPrimary: this.colorPrimary,
            size: this.size,
            playingTime: this.playingTime,
            duration: this.duration,
            durationVideoTime: this.durationVideoTime,
        };
        template.innerHTML = `${progressTemplate(context)}`;
        await this.shadowRoot.appendChild(template.content.cloneNode(true));
        helper.appendCommonStyling(this.shadowRoot)
        this.registerEvents()
    }

    registerEvents() {
        this.videoElement = this.shadowRoot.host.getRootNode()?.host?.shadowRoot?.querySelector("video")

        if (this.videoElement) {
            // Wait for the video's meta data to be loaded, then set the progress bar's max value to the duration of the video
            this.videoElement.addEventListener("loadedmetadata", () => {
                this.inputSeekbarElement.setAttribute('max', Math.floor(this.videoElement?.duration));
                this.shadowRoot.querySelector(".lora-duration-time").innerHTML = helper.formatVideoTime(Math.floor(this.videoElement?.duration));
            });

            // As the video is playing, update the progress bar
            this.videoElement.addEventListener("timeupdate", () => {
                if (this.seekingVideo) {
                    return;
                }
                let currentTime = this.videoElement?.currentTime;

                // For mobile browsers, ensure that the progress element's max attribute is set
                if (!this.inputSeekbarElement.getAttribute("max")) {
                    this.inputSeekbarElement.setAttribute('max', Math.floor(this.videoElement?.duration));
                }
                this.inputSeekbarElement.value = currentTime;
                this.shadowRoot.querySelector(`.lora-playing-time`).innerHTML = helper.formatVideoTime(Math.round(currentTime));
                // calculator progress percent
                let progressPercent = 0;
                if (this.videoElement?.duration && currentTime) {
                    progressPercent = Math.floor(
                        (currentTime * 100) / this.videoElement?.duration
                    );
                }
                this.inputSeekbarElement.style.backgroundSize = `${progressPercent}% 100%`;
            });
        }

        this.inputSeekbarElement = this.shadowRoot.querySelector(".lora-input-seekbar");

        this.inputSeekbarElement.onclick = (event) => {
            event.stopPropagation()
        }
        this.inputSeekbarElement.onmousedown = (event) => {
            event.stopPropagation()
            this.seekingVideo = true;
            this.emitSeeekingVideoEvent()
        };

        this.inputSeekbarElement.onmouseup = (event) => {
            event.stopPropagation()
            let seekbarValue = this.inputSeekbarElement.value;
            this.videoElement.currentTime = parseFloat(seekbarValue);
            this.seekingVideo = false;
            this.emitSeeekingVideoEvent()
        };
    }

    emitSeeekingVideoEvent() {
        this.shadowRoot.dispatchEvent(new CustomEvent("seeking-video", {
            composed: true,
            bubbles: true,
            detail: this.seekingVideo
        }));
    }
}
window.customElements.define("b-video-progress", VideoProgress);